/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';
import { TemplateExecutionListDTO, TemplateExecutionsSearchParams } from '../api/alerts/alertsClient.typings';

export enum AlertsExecutionActionType {
    OPEN_ALERTS_EXECUTIONS_PAGE = 'Alerts executions/ open page',
    CLOSE_ALERTS_EXECUTIONS_PAGE = 'Alerts executions/ close page',
    FETCH_ALERTS_EXECUTIONS_PAGE = 'Alerts executions/ fetch alerts executions',
    FETCH_ALERTS_EXECUTIONS_PAGE_SUCCESS = 'Alerts executions/ fetch alerts executions success',
    ALERTS_EXECUTION_PAGE_ERROR = 'Alerts executions/ alerts executions screen error',
}

export const openAlertsExecutionsPage = () => createAction(AlertsExecutionActionType.OPEN_ALERTS_EXECUTIONS_PAGE);

export const closeAlertsExecutionsPage = () => createAction(AlertsExecutionActionType.CLOSE_ALERTS_EXECUTIONS_PAGE);

export const fetchExecutionsPageAction = (id: number, params: TemplateExecutionsSearchParams) =>
    createAction(AlertsExecutionActionType.FETCH_ALERTS_EXECUTIONS_PAGE, { id, params });

export const fetchExecutionsPageSuccessAction = (list: TemplateExecutionListDTO) =>
    createAction(AlertsExecutionActionType.FETCH_ALERTS_EXECUTIONS_PAGE_SUCCESS, list);

export const alertsExecutionsErrorAction = (notification: Notification) =>
    createAction(AlertsExecutionActionType.ALERTS_EXECUTION_PAGE_ERROR, { notification });

export type AlertsExecutionsAction =
    | ReturnType<typeof fetchExecutionsPageAction>
    | ReturnType<typeof alertsExecutionsErrorAction>
    | ReturnType<typeof fetchExecutionsPageSuccessAction>
    | ReturnType<typeof openAlertsExecutionsPage>
    | ReturnType<typeof closeAlertsExecutionsPage>;
